import React from 'react';
import Layout from './containers/Layout/Layout';

const App = (props) => {
  return (
    <div className="App">
      <Layout settings={props.settings} />
    </div>
  );
};

export default App;
